// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zindex-xl[data-v-5223582e] {\n  z-index: 10;\n  -o-object-fit: fill;\n     object-fit: fill;\n}\n", ""]);
// Exports
module.exports = exports;
